module.exports = __webpack_public_path__ + "static/assets/80c946ec0ad302d1882f06a1c63b5842.png";